import { MarvelUser } from "models/users/MarvelUser";
import { services } from "api/serviceConfig";
import { makeAutoObservable } from "mobx";
import { PageRequest } from "api/sharedModels/PageRequest";
import { Customer } from "models/users/Customer";
import CustomerIdRequest from "api/sharedModels/CustomerIdRequest";
import { UserGroup } from "models/users/UserGroup";

export class UserStore {
    constructor() {
        makeAutoObservable(this);
    }

    validUsers: MarvelUser[] = [];

    users: MarvelUser[] = [];
    currentPage = 1;
    totalPages = 1;
    areUsersLoading = false;

    customers: Customer[] = [];
    areCustomersLoading = false;

    groups: UserGroup[] = [];
    groupsLoading = false;

    get isLastPage() {
        return this.currentPage === this.totalPages;
    }

    setPage = (page: number) => {
        this.currentPage = page;
    };

    clearUserPagination = () => {
        this.users = [];
        this.currentPage = 1;
        this.totalPages = 1;
    };

    movePage = (direction: "back" | "forward") => {
        direction === "back" ? this.currentPage-- : this.currentPage++;
    };

    loadUsers = async (request: PageRequest) => {
        this.areUsersLoading = true;

        try {
            const response = await services.UserManagement.getUsersList(request);
            this.users = response.data.items;
            this.totalPages = response.data.totalPages;
        } catch (error) {
            console.log(error);
        } finally {
            this.areUsersLoading = false;
        }
    };

    loadCustomers = async (request: PageRequest) => {
        this.areCustomersLoading = true;

        try {
            const response = await services.UserManagement.getCustomersList(request);
            this.customers = response.data.items;
        } catch (error) {
            console.log(error);
        } finally {
            this.areCustomersLoading = false;
        }
    };

    loadGroups = async (customerId: number) => {
        this.groupsLoading = true;

        try {
            const response =
                customerId !== -1
                    ? await services.UserManagement.getCustomerGroups({
                          customerId: customerId,
                          pageSize: 10000,
                          pageNumber: 1,
                      })
                    : await services.UserManagement.getGlobalGroups(10000, 1);

            this.groups = response.data.items;
        } catch (error) {
            console.log(error);
        } finally {
            this.groupsLoading = false;
        }
    };

    loadValidUsers = async (request: CustomerIdRequest) => {
        this.areUsersLoading = true;
        try {
            const response = await services.UserManagement.getValidUsers(request);
            this.validUsers = response.data.items;
        } catch (error) {
            console.log(error);
        } finally {
            this.areUsersLoading = false;
        }
    };
}
